import { z } from 'zod';
import { DEFAULT_INBOX_MODES, ONBOARDING_GOALS, THEME_MODES, UI_LANGS, } from '../types';
import { brandedId, emailField, ianaTimezone, optionalTrimmed, timestampMs, trimmedString, urlOrEmpty, } from './_helpers';
export const insertUserSchema = z.object({
    id: brandedId().optional(),
    email: emailField,
    emailVerified: z.boolean().default(false),
    name: optionalTrimmed(120),
    image: urlOrEmpty.optional(),
    uiLang: z.enum(UI_LANGS).default('fr'),
    timezone: ianaTimezone.default('Europe/Paris'),
    themeMode: z.enum(THEME_MODES).default('dark'),
    reduceMotion: z.boolean().default(false),
    inappNotifications: z.boolean().default(true),
    twoFactorEnabled: z.boolean().default(false),
    passwordChangedAt: timestampMs.optional(),
    onboardingCompletedAt: timestampMs.optional(),
    goal: z.enum(ONBOARDING_GOALS).optional(),
    defaultInboxMode: z.enum(DEFAULT_INBOX_MODES).optional(),
    stripeCustomerId: optionalTrimmed(120),
});
export const selectUserSchema = insertUserSchema.extend({
    id: brandedId(),
    createdAt: timestampMs,
    updatedAt: timestampMs,
    deletedAt: timestampMs.optional(),
});
export const updateUserSchema = insertUserSchema.partial().omit({ email: true });
/** Used by Settings → Profil form. Strict on email. */
export const userProfileFormSchema = z.object({
    name: trimmedString(120),
    email: emailField,
    uiLang: z.enum(UI_LANGS),
    timezone: ianaTimezone,
    themeMode: z.enum(THEME_MODES),
    reduceMotion: z.boolean(),
    inappNotifications: z.boolean(),
});
/** Sign-up payload — public route. */
export const signUpSchema = z
    .object({
    email: emailField,
    password: z.string().min(10).max(256),
    name: trimmedString(120).optional(),
    locale: z.enum(UI_LANGS).default('fr'),
})
    .strict();
/** Sign-in payload — public route. */
export const signInSchema = z
    .object({
    email: emailField,
    password: z.string().min(1).max(256),
})
    .strict();
export const passwordChangeSchema = z
    .object({
    currentPassword: z.string().min(1).max(256),
    newPassword: z.string().min(10).max(256),
})
    .strict()
    .refine((v) => v.currentPassword !== v.newPassword, {
    path: ['newPassword'],
    message: 'must differ from current password',
});
export const forgotPasswordSchema = z.object({ email: emailField }).strict();
export const resetPasswordSchema = z
    .object({
    token: trimmedString(256),
    newPassword: z.string().min(10).max(256),
})
    .strict();
//# sourceMappingURL=user.js.map